module.exports = __webpack_public_path__ + "static/media/wwu.f9076867.png";